import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { ttAuth, ttPublish } from 'services/social.service';
import { getFinalCut } from 'services/finalcut.service';
import { RootState } from 'store/store';
import { LocalStore } from 'constants/localstore';
import { Error } from 'components/app/_helpers/app-errors.helper';
const SLICE_ID = 'tiktok';

const login = createAsyncThunk(SLICE_ID + '/login', async (finalcutId: FinalcutId, { rejectWithValue }) => {
  try {
    const url = (await ttAuth(finalcutId)).data.url;
    window.open(url, '_blank', 'width=800,height=600,top=100,left=200,resizable=share');
  } catch (error) {
    return rejectWithValue(Error.reduxErrorHandler(error));
  }
});

export const ttShare = createAsyncThunk(SLICE_ID + '/share', async (_, { getState, dispatch, rejectWithValue }) => {
  const { id, url } = (getState() as RootState).fc__data;
  const token = localStorage.getItem(LocalStore.tiktokOAuth);
  if (!id || !url) return;
  if (token)
    await ttPublish(url, token)
      .then(() => toast.success('The video file has been successfully shared on TikTok! 🎉'))
      .catch((err) => {
        if (err === 401) dispatch(login(id));
        else return rejectWithValue(Error.reduxErrorHandler(err));
      });
  else await dispatch(login(id));
});

export const getFileLink = createAsyncThunk(
  SLICE_ID + '/getFileLink',
  async (finalcutId: FinalcutId, { rejectWithValue }) => {
    try {
      const versions = (await getFinalCut(finalcutId)).data.finalCutVersions;
      return versions[versions.length - 1].url;
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);
